.region {
  position: fixed;
  left: 50%;
  bottom: calc(24px + env(safe-area-inset-bottom));
  z-index: 50;
  transform: translateX(-50%);
  display: grid;
  gap: 8px;
  width: min(420px, calc(100% - 32px));
  pointer-events: none;
}

.toast {
  padding: 12px 16px;
  border-radius: var(--radius);
  background: rgb(20 28 25 / 0.94);
  border: 1px solid var(--color-border);
  box-shadow: 0 16px 40px rgb(0 0 0 / 0.45);
  backdrop-filter: blur(12px);
  text-align: center;
  font-size: 0.95rem;
}
